import { string } from '@amcharts/amcharts4/core';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-code-input',
  templateUrl: './code-input.component.html',
  styleUrls: ['./code-input.component.scss']
})
export class CodeInputComponent implements OnInit {
  @Input("inputCount") inputCount: number;
  inputs: number[] = [];

  @Output('code') codeComplete = new EventEmitter<string>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['inputCount']) {
      this.inputs = Array(this.inputCount).fill(0).map((x, i) => i);

    }
  }

  constructor() {
  }

  ngAfterViewInit(): void {
    const firstInput = document.getElementById('otpInput0');
    (firstInput as HTMLElement).focus();
  }

  ngOnInit() {

  }

  onInput(event: any, index: number): void {
    const inputElement = event.target;
    const nextInput = document.getElementById('otpInput' + (index + 1));
    if (inputElement.value.length === 1) {
      if (nextInput) {
        (nextInput as HTMLElement).focus();
      } else {
      }
    }

    let values = '';
    for (let index = 0; index < this.inputCount; index++) {
      const input = <HTMLInputElement>document.getElementById('otpInput' + index);
      if (input) {
        values += `${input.value}`;
      }

    }
    this.codeComplete.emit(values);
  }
  onKeydown(event: KeyboardEvent, index: number): void {
    const inputElement = event.target as HTMLInputElement;
    const prevInput = document.getElementById('otpInput' + (index - 1));

    if (event.key === 'Backspace') {
      inputElement.value = '';
      (prevInput as HTMLElement).focus();
    }
  }

  clear() {

    for (let index = 0; index < this.inputCount; index++) {
      const input = <HTMLInputElement>document.getElementById('otpInput' + index);
      if (input) {
        input.value = null;
      }

    }

    const firstInput = <HTMLInputElement>document.getElementById('otpInput' + 0);
    (firstInput as HTMLElement).focus();
  }
}
